import React, {useEffect} from "react";
import "./TrainersPage.sass"
import TeacherGrid from "../../../_components/teacher/TeacherGrid";
import TrainersPanel from "../../../_components/teacher/trainers/TrainersPanel";
import {useSelector} from "react-redux";
import {ROLE_STUDENT} from "../../../common/roles";
import StudentGrid from "../../../_components/student/StudentGrid";

export default function TrainersPage() {

    const {current} = useSelector(state => state.auth);

    useEffect(() => {
        document.title = 'КьюАй - Тренажёры';
    }, [])


    return (
        <div className="TrainersPage-wrapper">
            {current.role === ROLE_STUDENT ? <StudentGrid/> : <TeacherGrid/>}
            <TrainersPanel/>
        </div>
    )
}